/**
 * Order cancellation eligibility rules.
 *
 * Shared between OrderView (legacy) and OrderViewV2. The list below is the
 * canonical source of truth for whether an order can be cancelled from the UI.
 * When adding a new OrderStatus, decide explicitly whether it belongs here.
 */
import { GraphQL } from "@rpi/openapi-api";

export const CANCELLABLE_STATUSES: GraphQL.OrderStatus[] = [
  GraphQL.OrderStatus.Created,
  GraphQL.OrderStatus.PricingCompleted,
  GraphQL.OrderStatus.Received,
  GraphQL.OrderStatus.ReceivedOverLimit,
  GraphQL.OrderStatus.WaitingInHoldingBin,
  GraphQL.OrderStatus.WaitingForSubmission,
  GraphQL.OrderStatus.Submitting,
  GraphQL.OrderStatus.Submitted,
];

export function canCancelOrder(order: { status?: GraphQL.OrderStatus | null }): boolean {
  return order.status ? CANCELLABLE_STATUSES.includes(order.status) : false;
}
